/* eslint-disable react/prop-types */
import { Container, Grid, Stack, styled } from "@mui/material";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import AppSection from "../../../components/AppSection";
import { GoogleBannerAds } from "../../../components/GoogleAds";
import Page from '../../../components/Page';
import useLocales from "../../../hooks/useLocales";
import useResponsive from "../../../hooks/useResponsive";
import useSettings from "../../../hooks/useSettings";
import Layout from '../../../layouts';
import { removeFailedPass } from "../../../redux/slices/gplx.failSituation.slice";
import { removeSituationAnswerFailed } from "../../../redux/slices/gplx.situation.slice";
import Claimnation from "../../../sections/situation/Claimnation";
import GuideSection from "../../../sections/situation/GuideSection";
import MenuSection from "../../../sections/wrongSituation/MenuSection";
import { SituationHeader } from "../../../sections/wrongSituation/SituationHeader";
import VideoSection from "../../../sections/wrongSituation/VideoSection";

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(10),
  paddingBottom: theme.spacing(10),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(15),
    paddingBottom: theme.spacing(15),
  },
}));

Situation.getLayout = function getLayout(page) {
  return <Layout variant="main">{page}</Layout>;
};

export default function Situation() {
  const { translate } = useLocales();
  const dispatch = useDispatch();

  const { themeStretch } = useSettings();
  const isDesktop = useResponsive('up', 'md');

  useEffect(() => () => {
    dispatch(removeFailedPass());
    dispatch(removeSituationAnswerFailed());
  }, []);

  return (
    <Page title={translate('wrongSituation.title')} description={translate('wrongSituation.description')}>
      <Container maxWidth={themeStretch ? 'xl' : 'lg'}>
        <RootStyle>
          <SituationHeader />
          <Grid container my={5} >
            <Grid item xs={12} md={3}>
              <MenuSection />
              {isDesktop && <Stack p={1} spacing={2}>
                <AppSection />
                <GuideSection />
                <GoogleBannerAds />
              </Stack>}
            </Grid>
            <Grid item xs={12} md={9}>
              <VideoSection />
              {!isDesktop && <Stack p={1} spacing={2}>
                <AppSection />
                <GuideSection />
                <GoogleBannerAds />
              </Stack>}
            </Grid>
          </Grid>
          <Claimnation />
        </RootStyle>
      </Container>
    </Page >
  );
}